export default {
    updatedCandidate: {},
    region: {}
}